<template>
  <div >
    <v-navigation-drawer v-model="drawer" class="__theme-shadow menuItem">
      <!-- Logo -->
      <v-list class="text-center">
        <img width="150" class="mt-2" :src="require('@/assets/img/logo.png')" alt="Logo">
      </v-list>

      <v-divider></v-divider>

      <!-- Menu -->
      <v-list nav density="comfortable">

        <v-list-item prepend-icon="mdi-view-dashboard-outline" title="ড্যাশবোর্ড" to="/dashboard"/>
        <v-list-group value="settings">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" prepend-icon="mdi-calendar-month" title="ক্যালেন্ডার"/>
          </template>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="ক্যালেন্ডার" to="/calendar"/>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="আমার ইভেন্ট তালিকা" to="/event"/>
        </v-list-group>

        <v-list-item prepend-icon="mdi-text-search-variant" title="অনুসন্ধান" to="/search"/>
<!--        <v-list-item prepend-icon="mdi-account" title="Users" to="/users"/>-->
        <!-- Dropdown Menu -->
        <v-list-group value="blog">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" prepend-icon="mdi-account-group" title="পিএমআইএস"/>
          </template>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="আমার প্রোফাইল" to="/user-profile"/>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="এসিআর সংক্রান্ত তথ্য" to="/acr-related-information"/>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="ব্যক্তিগত তথ্য" to="/personal-information"/>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="পারিবারিক তথ্য" to="/family-information"/>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="ঠিকানাসংক্রান্ত তথ্য" to="/address-information"/>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="শিক্ষাসংক্রান্ত তথ্য" to="/educational-information"/>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="চাকরিসংক্রান্ত তথ্য" to="/job-information"/>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="বিশেষ গুণাবলি" to="/special-quality"/>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="প্রশিক্ষণ" to="/training"/>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="বিদেশ ভ্রমণ" to="/foreign-trip"/>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="সম্পদ বিবরণী" to="/asset-statement"/>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="আবেদনের খসড়া ও দাখিল" to="/application-draft-forms"/>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="আবেদনের সর্বশেষ অবস্থা" to="/latest-application-status"/>
        </v-list-group>
        <v-list-item prepend-icon="mdi-gavel" title="সরকারি আদেশ" to="/government-orders"/>

<!--        <v-list-group value="settings">
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" prepend-icon="mdi-cog" title="Settings"/>
          </template>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="Profile Settings" to="/profile-settings"/>
          <v-list-item prepend-icon="mdi-arrow-right-thin" title="Security" to="/security"/>
        </v-list-group>-->
      </v-list>
      <!-- Footer -->
      <template #append>
        <v-list nav density="comfortable">
          <v-list-item @click="logout()"  class="ma-2" prepend-icon="mdi-logout" title="Logout"/>
        </v-list>
      </template>
    </v-navigation-drawer>

    <v-app-bar  app class="app-bg" height="70">
      <v-app-bar-nav-icon variant="text" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $route.meta.title }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <ThemeMode />
      <v-btn class="__btn_bg" variant="text" icon="mdi-magnify"></v-btn>
      <v-btn class="__btn_bg" variant="text" icon="mdi-filter"></v-btn>
      <template #append>
        <v-btn class="text-none me-2" height="48" icon slim>
          <v-avatar color="surface-light" :image="require('@/assets/img/user.png')" size="48" />
          <v-menu activator="parent">
            <v-list density="compact" nav>
              <v-list-item :title="$store.getters.authUser?.name" :subtitle="$store.getters.authUser?.email"></v-list-item>
              <v-divider></v-divider>
              <v-list-item :to="'/update-profile'" append-icon="mdi-account-plus" link title="Edit Profile" />
              <v-list-item @click="logout()" append-icon="mdi-logout" link title="Logout" />
            </v-list>
          </v-menu>
        </v-btn>
      </template>

    </v-app-bar>
  </div>
</template>

<script>
import ThemeMode from "@/components/ThemeMode.vue";

export default {
  name: 'HeaderComponent',
  components: {ThemeMode},

  data: () => ({
    drawer: false,
    userImg: "@/assets/img/user.png",
  }),

  mounted() {
    this.drawerView();
  },

  methods: {
    drawerView() {
      if (window.innerWidth < 1280) {
        this.drawer = false
      } else {
        this.drawer = true
      }
    },

    logout() {
      this.$store.dispatch("logout");
      this.$router.push({ path: `/` });
    },
  }
}
</script>